import { ref, onMounted } from 'vue';

export function useMediumArticles(mediumUsername = 'iqbalarauf') {
	const articles = ref([]);
	const loading = ref(false);
	const error = ref(null);

	const fetchMediumArticles = async () => {
		loading.value = true;
		error.value = null;

		try {
			// Using RSS2JSON API to convert Medium RSS feed to JSON
			const rssUrl = `https://medium.com/feed/@${mediumUsername}`;
			const apiUrl = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(rssUrl)}`;

			const response = await fetch(apiUrl);
			
			if (!response.ok) {
				throw new Error('Failed to fetch articles');
			}

			const data = await response.json();

			if (data.status === 'ok' && data.items && data.items.length > 0) {
				// Filter and get top 5 articles
				const items = data.items.slice(0, 5);

				articles.value = items.map((item) => {
					const cleanDescription = item.description
						? item.description.replace(/<[^>]*>/g, '').substring(0, 300) + '...'
						: 'No description available';

					return {
						id: item.guid || item.link,
						title: item.title || 'Untitled',
						description: cleanDescription,
						link: item.link,
						pubDate: item.pubDate 
							? new Date(item.pubDate).toLocaleDateString('id-ID', {
									year: 'numeric',
									month: 'long',
									day: 'numeric',
								})
							: 'Unknown date',
						thumbnail: item.thumbnail || extractImageFromContent(item.content),
						author: item.author || mediumUsername,
						categories: item.categories || [],
					};
				});
			} else {
				error.value = 'Tidak dapat menemukan artikel dari Medium';
			}
		} catch (err) {
			error.value = 'Terjadi kesalahan: ' + (err.message || 'Unknown error');
			console.error('Error fetching Medium articles:', err);
		} finally {
			loading.value = false;
		}
	};

	const extractImageFromContent = (content) => {
		if (!content) return null;
		try {
			const parser = new DOMParser();
			const doc = parser.parseFromString(content, 'text/html');
			const img = doc.querySelector('img');
			return img ? img.src : null;
		} catch (e) {
			return null;
		}
	};

	onMounted(() => {
		fetchMediumArticles();
	});

	return {
		articles,
		loading,
		error,
		fetchMediumArticles,
	};
}

